import { Component } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
	MatProgressSpinnerModule,
	ProgressSpinnerMode
} from '@angular/material/progress-spinner';

@Component({
	selector: 'app-loading-modal',
	templateUrl: './loading-modal.component.html',
	standalone: true,
	imports: [MatProgressSpinnerModule],
	styleUrls: ['./loading-modal.component.scss']
})
export class LoadingModalComponent {
	color: ThemePalette = 'primary';
	mode: ProgressSpinnerMode = 'indeterminate';
	value = 50;

	constructor(public dialogRef: MatDialogRef<LoadingModalComponent>) {}

	close(): void {
		this.dialogRef.close();
	}
}
